



















import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';
import { MuArtist } from '../../store/artists/types';

@Component({})
export default class ArtistDisplay extends Vue {
    @Prop()
    artist!: MuArtist;
}

